import { dealInfoHelpers } from 'widget/player-widget';
import commonTranslations from 'shared/translations/overlay-common-translations';
import formatMessageWithDealInfo from '../_format-message-with-deal-info';
import { isSubscriptionEnabled, isSubscribedTo } from 'shared/ui-selectors/channel/pricing';


/**
 * Is video subscribe button visible
 * @param props {Object}
 * @param props.channel {Object}
 * @return {Boolean}
 */
export function isVisible({ channel }) {
  return isSubscriptionEnabled(channel) && !isSubscribedTo(channel);
}

/**
 * Video sign in to play button text
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.translation {Object} default is commonTranslations.getSubscription
 * @return {React.Component}
 */
export default function renderSubscribeButtonText(props) {
  if (!isVisible(props)) {
    return null;
  }

  return formatMessageWithDealInfo(
    props.translation || commonTranslations.getSubscription,
    dealInfoHelpers.getSubscriptionPriceInfo(props.channel.dealInfo)
  );
}



// WEBPACK FOOTER //
// ./src/widget/components/overlay-texts/channel/subscribe-button-text.js